import React from 'react';
import VISIBLE from 'constants/visibility';

/**
 * @description Component for listening to VisibilityAPI
 * @type Higher order component
 * @class Visibility
 * @example
 * const Visible = Visibility(Component);
 * <Visible //ms />
 */
const Visibility = ComposedComponent =>
    class Visibility extends React.Component {
        state = {
            visible: true
        };

        componentDidMount() {
            this.register();
        }

        componentWillUnmount() {
            this.deregister();
        }

        /**
         * @description Checks if the current page is visible and updates state accordingly;
         */
        handleVisibilityChange = () => {
            let isVisible = !document[VISIBLE.HIDDEN];
            if (this.state.isVisible !== isVisible) {
                this.setState({
                    visible: isVisible
                });
            }
        };

        /**
         * Register Event Handlers;
         */
        register = () => {
            this.handleVisibilityChange();
            document.addEventListener(
                VISIBLE.EVENTNAME,
                this.handleVisibilityChange,
                false
            );
        };

        /**
         * Remove event handlers
         */
        deregister = () => {
            document.removeEventListener(
                VISIBLE.EVENTNAME,
                this.handleVisibilityChange,
                false
            );
        };

        render() {
            return (
                <ComposedComponent
                    {...this.props}
                    visible={this.state.visible}
                />
            );
        }
    };
export default Visibility;
